import styled from 'styled-components'

import { AmountFormatted, VolumeShortFormatted } from '@root/shared/core/format'

import type { ClassNameProps } from '@root/shared/react'
import type BigNumber from 'bignumber.js'

type HolderTableTradeCellColor = 'green' | 'red'
type HolderTableTradeCellProps = {
  volumeInUsd: BigNumber
  volumeInToken: BigNumber
  number: number
  color: HolderTableTradeCellColor
} & ClassNameProps

export const HolderTableTradeCell = (props: HolderTableTradeCellProps) => {
  return (
    <Root className={props.className}>
      <Top $color={props.color}>
        <VolumeShortFormatted volume={props.volumeInUsd} />
      </Top>
      <Bottom>
        <AmountFormatted amount={props.volumeInToken} />
        {` / `}
        {props.number.toString()}
      </Bottom>
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`
const Top = styled.div<{ $color: HolderTableTradeCellColor }>`
  color: ${(props) =>
    props.$color === 'green' ? 'var(--up-9)' : 'var(--down-9)'};

  font-size: 12px;
  font-weight: 500;
  line-height: normal;
`
const Bottom = styled.div`
  color: var(--text-11);

  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`
